import gsap from 'gsap';
import $ from '../core/Dom';

export default el => {
    const $el = $(el);

    const $button = $el.find('button[aria-expanded]');
    const $hidden = $el.find('li[hidden]');

    const onClick = e => {
        e.preventDefault();

        // Reveal the hidden items and fade them in for a touch of polish
        $hidden.attr('hidden', null);
        gsap.from($hidden.get(), { duration: 0.4, opacity: 0, ease: 'quart.out' });

        $button.attr('aria-expanded', 'true');

        // One-way reveal — drop the trigger once everything's shown. Inline
        // display wins over the wrapper's `flex` utility, which `[hidden]` wouldn't.
        $button.parent().css('display', 'none');
    };

    const init = () => {
        if (!$button.length || !$hidden.length) {
            return;
        }

        $button.on('click', onClick);
    };

    const destroy = () => {
        $button.off('click', onClick);
        gsap.killTweensOf($hidden.get());
    };

    return {
        init,
        destroy
    };
};
